
import wx from 'weixin-js-sdk'
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
pickerStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
wash_code:'',
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
checkAllStatus:false,
allText:'全选',
ids:'',
factorys:[],
factory_id:0,
}
},
created(){
this.config();


},
amount(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
reset(){
this.wash_code = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
getList(){
this.$api.getWashCode({code:this.wash_code}).then((res)=>{
if(res){
console.log(res);
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
cancel(){
this.$func.confirm('确认提交撤单？','提示',()=>{
this.$func.startLoading();
this.$api.cancelRecord({code:this.wash_code}).then((res)=>{
if(res){
this.reset();
this.$func.endLoading();
}
})
})
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.wash_code = res.resultStr.split(',')[1];
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/cancelRecord.vue